import {Stack, styled, Typography, useMediaQuery} from "@mui/material";
import h3 from '../assets/gallery/h3.jpg';
import c4 from '../assets/gallery/c4.JPG';
import c2 from '../assets/gallery/c2.JPG';
import h2 from '../assets/gallery/h2.jpg';
import h4 from '../assets/gallery/h4.jpg';
import h5 from '../assets/gallery/h5.jpg';

const Home = () => {
    const isMobile = useMediaQuery('(max-width:800px)');

    const Photo = styled('img')({
        width: isMobile ? '100%' : '45%',
        flexShrink: 0,
        aspectRatio: '4 / 3',
        objectFit: 'cover',
        padding: '20px',
        boxSizing: 'border-box',
    });

    return (
        <Stack direction="column" padding="20px">
            <Typography variant="h4" component="h1" fontWeight="medium" marginBottom="10px">
                Despre noi
            </Typography>

            <Stack direction={isMobile ? "column" : "row"} alignItems="center">
                <Stack direction="column" flex={1}>
                    <Typography variant="body1" padding="10px 0">
                        Taberele Chiron vă oferă tabere de vară pentru copii la mare, în Grecia, într-un cadru sigur,
                        prietenos și plin de oportunități de învățare. Aceste tabere sunt concepute pentru a îmbina
                        educația cu relaxarea și aventura, astfel încât participanții să se bucure de o experiență
                        memorabilă pe durata vacanței de vară.
                    </Typography>
                    <Typography variant="body1" padding="10px 0">
                        În cadrul programului, organizăm tabere de limba engleză, dar și tabere dedicate limbilor
                        clasice – greaca și latina – unde copiii vor avea ocazia să descopere nu doar limbile în sine,
                        ci și culturile, istoria și civilizațiile care le-au dat naștere. Activitățile educative sunt
                        concepute într-un mod interactiv și captivant, pentru a stimula curiozitatea și dorința de a
                        învăța.
                    </Typography>
                </Stack>
                <Photo src={h3} alt="imagine din Grecia"/>
            </Stack>

            <Stack direction={isMobile ? "column-reverse" : "row"} alignItems="center">
                <Photo src={c4} alt="imagine din Grecia"/>
                <Stack direction="column" flex={1}>
                    <Typography variant="body1" padding="10px 0">
                        Pe lângă cursuri și ateliere, programul include numeroase activități recreative, timp petrecut
                        pe plajă, jocuri de grup și momente de socializare. Profesorii și coordonatorii taberei se vor
                        asigura că există un echilibru armonios între învățare și relaxare, creând astfel o experiență
                        plăcută și utilă pentru fiecare participant.
                    </Typography>
                    <Typography variant="body1" padding="10px 0">
                        Prin această combinație atent gândită de educație, cultură și distracție, Taberele Chiron oferă
                        copiilor o vacanță de vară care nu este doar relaxantă, ci și formativă, contribuind la
                        dezvoltarea lor personală, intelectuală și culturală.
                    </Typography>
                </Stack>
            </Stack>

            <Typography variant="h4" component="h2" fontWeight="medium" marginBottom="10px" marginTop="20px">
                De ce Taberele Chiron?
            </Typography>

            <Stack direction={isMobile ? "column" : "row"} alignItems="center">
                <Stack direction="column" flex={1}>
                    <Typography variant="body1" padding="10px 0">
                        Profesorul lui Ahile, dar și al altor eroi, centaurul Chiron este figura care a inspirat ideea
                        taberelor de limbi clasice pe care le organizăm. De ce? Pentru că, trăind în mijlocul naturii,
                        Chiron este simbolul învățării firești, în armonie cu ritmurile locului și ale timpului. De
                        aceea Taberele Chiron presupun retragerea în mijlocul sau în imediata proximitate a naturii, de
                        la care vom învăța să învățăm lucruri neperimabile, mereu vii, proapspete și firești, la fel
                        ca ea.
                    </Typography>
                </Stack>
                <Photo src={c2} alt="imagine din Grecia"/>
            </Stack>

            <Typography variant="h4" component="h2" fontWeight="medium" marginBottom="10px" marginTop="20px">
                De ce limbile clasice?
            </Typography>

            <Stack direction={isMobile ? "column-reverse" : "row"} alignItems="center">
                <Photo src={h2} alt="imagine din Grecia"/>
                <Stack direction="column" flex={1}>
                    <Typography variant="body1" padding="10px 0">
                        Limbile clasice, prin autorii care au creat în ele, sunt calea regală către un mod de viață
                        armonios, care oferă minții și inimii hrana de care au atât de mare nevoie, mai ales azi. A
                        învăța latina și greaca veche înseamnă să te îmbogățești cu noi posibilități de a gândi, pe
                        care nimeni nu le poate bănui înainte de această experiență. Pentru că sintaxa lor e mai
                        complexă – deci mai subtilă și mai inteligentă –, iar vocabularul lor (din care decurge și cel
                        al limbilor moderne) poartă semnificațiile acelei îndelungate experiențe de viață care este
                        istoria din care venim.
                    </Typography>
                </Stack>
            </Stack>

            <Typography variant="h4" component="h2" fontWeight="medium" marginBottom="10px" marginTop="20px">
                Un parcurs personal, care ne împlinește
            </Typography>

            <Stack direction={isMobile ? "column" : "row"} alignItems="center">
                <Stack direction="column" flex={1}>
                    <Typography variant="body1" padding="10px 0">
                        Nicio traducere gata servită de un om sau, mai nou, de un robot nu poate înlocui parcursul
                        propriu. Contactul direct cu textul (mai ales în aceste limbi atât de rafinate și prin
                        intermediul autorilor clasici, care mizează mereu pe inteligența cititorului, stimulând-o la
                        fiecare frază) ne face să înțelegem că lucrurile bune, frumoase și esențiale nu trebuie
                        externalizate ci, din contră, parcurse și trăite la modul cel mai personal.
                    </Typography>
                    <Typography variant="body1" padding="10px 0">
                        Iată de ce suntem convinși că Taberele Chiron vor fi o κτῆμα ἐς αἰεί, cum ar spune Tucidide,
                        adică „o agoniseală pentru totdeauna". Vom prinde gustul unui fel de viață prin care, cum bine
                        observa Horatius în Arta poetică, omne tulit punctum, qui miscuit utile dulci („și-a atins
                        țelul cel care a îmbinat utilul cu plăcutul").
                    </Typography>
                </Stack>
                <Photo src={h4} alt="imagine din Grecia"/>
            </Stack>

            <Typography variant="h4" component="h2" fontWeight="medium" marginBottom="10px" marginTop="20px">
                Ce am primit și noi, vrem să dăm mai departe
            </Typography>

            <Stack direction={isMobile ? "column-reverse" : "row"} alignItems="center">
                <Photo src={h5} alt="imagine din Grecia"/>
                <Stack direction="column" flex={1}>
                    <Typography variant="body1" padding="10px 0">
                        Pe scurt, limbile clasice (greaca veche și latina) ne îmbogățesc, ne structurează gândirea, ne
                        rafinează sensibilitatea și ne fac mai puternici, prin autorii care s-au exprimat în ele,
                        dându-ne, în fața multelor schimbări ale vieții, ceva care rămâne. Noi înșine, ca organizatori,
                        am fost mânați de experiența proprie, îmboldiți, după exemplul stoicilor romani, de dorința de
                        a lărgi cercul binelui de care avem parte, așa încât să îi includă și pe alții.
                    </Typography>
                    <Typography variant="body1" padding="10px 0">
                        Înainte să ne cunoaștem la fața locurilor în care vor prinde viață Taberele Chiron, îngăduiți-ne
                        să ne prezentăm pe scurt: suntem Mirela Nazâru, absolventă de Limbi Clasice la Universitatea
                        Babeș-Bolyai și Ștefan Lungu, absolvent de Limbi Clasice la Universitatea din București. Pe
                        lângă pasiunea noastră pentru latină și greaca veche, ne leagă și faptul că urmăm, în prezent,
                        programul masteral de Traductologie Latino-Romanică (modulul de Clasice) la Universitatea din
                        București.
                    </Typography>
                </Stack>
            </Stack>
            <Typography variant="body1" padding="10px 0">
                Din tot ce am primit de la profesorii noștri și am descoperit pe cont propriu, vrem să împărțim
                și cu voi, convinși fiind că ne vom îmbogăți unii pe alții și vom lega prietenii noi și
                durabile. Ca orice lucru bun, totul începe cu un gând firav, cum e acesta: ce-ar fi să mă
                înscriu? Noi zicem că ar fi bine 😄
            </Typography>
        </Stack>
    )
}

export default Home;